// This file should be auto-generated from design system

import {type ThemeOptions} from '@mui/material';
import {ExpandMore} from '@mui/icons-material';
import '@mui/x-data-grid/themeAugmentation';
import RadioSelectedSvg from './components/.exported_teleporthq/groups wip-react/public/playground_assets/svgradiosi706-ku8.svg';

/* eslint-disable @typescript-eslint/consistent-type-definitions, @typescript-eslint/naming-convention */
export const externalFonts = [
	'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap',
];

export const themeVars = {
	spacing: 22,
	border: {
		width: '1px',
		radius: '5px',
	},
	outline: {
		width: '2px',
		style: 'dashed',
		offset: '2px',
	},
	color: {
		white: 'white',
		black: 'black',
		blue: {
			100: '#e6eef6',
			200: '#b9cce3',
			300: '#4d87bf',
			500: '#0054a4',
			800: '#003672',
		},
		gray: {
			100: '#f0f2f3',
			300: '#c6c7cc',
			500: '#66676b',
			600: '#44464b',
			800: '#34363b',
		},
		red: {
			100: '#fce6e3',
			300: '#f7a7a6',
			500: '#ed1b34',
			800: '#c4132a',
		},
		yellow: {
			100: '#fcfbe0',
			300: '#d6e089',
			500: '#efaa00',
			800: '#ad6b00',
		},
		green: {
			100: '#ebfbde',
			300: '#b2ec99',
			500: '#60c150',
			800: '#258039',
		},
	},
};

const typographyVars = {
	DesktopTitle: {
		fontWeight: 800,
		fontSize: '45px',
	},
	DesktopH1: {
		fontWeight: 800,
		fontSize: '32px',
	},
	DesktopH2: {
		fontWeight: 800,
		fontSize: '24px',
	},
	DesktopH3: {
		fontWeight: 700,
		fontSize: '20px',
	},
	Subhead1: {
		fontWeight: 600,
		fontSize: '15px',
	},
	Subhead2: {
		fontWeight: 400,
		fontSize: '12px',
	},
	Paragraph1: {
		fontWeight: 400,
		fontSize: '18px',
	},
	Paragraph2: {
		fontWeight: 400,
		fontSize: '16px',
	},
	Paragraph3: {
		fontWeight: 400,
		fontSize: '14px',
	},
	UIObjectsButton: {
		fontWeight: 600,
	},
	UIObjectsText1: {
		fontWeight: 400,
		fontSize: '18px',
	},
	UIObjectsText4: {
		fontWeight: 400,
		fontSize: '12px',
	},
	'UIObjectsText3BOLDCAPS-2': {
		fontWeight: 700,
	},
};

export const muiTheme: ThemeOptions = {
	...themeVars,
	palette: {
		primary: {
			main: themeVars.color.blue[500],
			light: themeVars.color.blue[200],
			dark: themeVars.color.blue[800],
			contrastText: themeVars.color.blue[100],
		},
		error: {
			main: themeVars.color.red[500],
			light: themeVars.color.red[300],
			dark: themeVars.color.red[800],
			contrastText: themeVars.color.red[100],
		},
		warning: {
			main: themeVars.color.yellow[500],
			light: themeVars.color.yellow[300],
			dark: themeVars.color.yellow[800],
			contrastText: themeVars.color.yellow[100],
		},
		success: {
			main: themeVars.color.green[500],
			light: themeVars.color.green[300],
			dark: themeVars.color.green[800],
			contrastText: themeVars.color.green[100],
		},
	},
	breakpoints: {
		values: {
			xs: 0,
			sm: 600,
			md: 840,
			lg: 1080,
			xl: 1440,
			xxl: 1920,
		},
		step: 100,
	},
	typography: {
		fontFamily: 'Montserrat',
		...typographyVars,
	},
	components: {
		MuiButton: {
			defaultProps: {
				variant: 'contained',
				disableRipple: true,
			},
			styleOverrides: {
				root: {
					textTransform: 'none',
					fontFamily: 'Montserrat',
					color: themeVars.color.white,
					borderRadius: themeVars.border.radius,
					fontSize: '18px',
					fontWeight: 600,
					padding: '12px 22px',
					'& .MuiBox-root': {
						color: 'unset',
					},
					'&:hover': {
						backgroundColor: themeVars.color.blue[500],
						boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.3)',
					},
					'&:active': {
						backgroundColor: themeVars.color.blue[800],
						boxShadow: 'none',
					},
					'&.Mui-focusVisible': {
						outline: `${themeVars.color.blue[500]} ${themeVars.outline.width} ${themeVars.outline.style}`,
						outlineOffset: themeVars.outline.offset,
					},
					'&.Mui-disabled': {
						color: themeVars.color.white,
						backgroundColor: themeVars.color.blue[200],
					},
				},
				text: {
					color: themeVars.color.blue[500],
					'&:hover': {
						backgroundColor: themeVars.color.white,
						boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.3)',
					},
					'&:active': {
						backgroundColor: themeVars.color.blue[200],
						boxShadow: 'none',
					},
					'&.Mui-focusVisible': {
						outline: `${themeVars.color.blue[500]} ${themeVars.outline.width} ${themeVars.outline.style}`,
						outlineOffset: themeVars.outline.offset,
					},
					'&.Mui-disabled': {
						backgroundColor: themeVars.color.white,
						color: themeVars.color.blue[200],
						'& svg path': {
							fill: themeVars.color.blue[200],
						},
					},
				},
				outlined: {
					color: themeVars.color.blue[500],
					borderColor: themeVars.color.blue[500],
					'& .MuiBox-outlined': {
						borderColor: themeVars.color.blue[500],
					},
					'&:hover': {
						backgroundColor: themeVars.color.white,
						boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.3)',
					},
					'&:active': {
						backgroundColor: themeVars.color.blue[200],
						boxShadow: 'none',
					},
					'&.Mui-focusVisible': {
						outline: `${themeVars.color.blue[500]} ${themeVars.outline.width} ${themeVars.outline.style}`,
						outlineOffset: themeVars.outline.offset,
					},
					'&.Mui-disabled': {
						backgroundColor: themeVars.color.white,
						color: themeVars.color.blue[200],
						borderColor: themeVars.color.blue[200],
					},
				},
			},
		},
		MuiSelect: {
			defaultProps: {
				IconComponent: ExpandMore,
			},
			styleOverrides: {
				icon: {
					color: themeVars.color.blue[500],
				},
			},
		},
		MuiSkeleton: {
			defaultProps: {
				width: '100%',
				height: '100%',
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					fontSize: '18px',
					fontFamily: 'Montserrat',
					color: themeVars.color.gray[600],
					'&.Mui-disabled': {
						color: themeVars.color.gray[300],
					},
					'&.Mui-focused': {
						color: themeVars.color.gray[600],
					},
				},
				shrink: {
					transform: 'translate(14px, 6px) scale(0.66)',
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				notchedOutline: {
					borderRadius: themeVars.border.radius,
					borderColor: themeVars.color.gray[600],
				},
				root: {
					height: '52px',
					borderRadius: themeVars.border.radius,
					'&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
						borderColor: themeVars.color.gray[100],
					},
					'&:hover': {
						boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.3)',
					},
					'&.Mui-focused': {
						outline: `${themeVars.color.blue[500]} ${themeVars.outline.width} ${themeVars.outline.style}`,
						outlineOffset: themeVars.outline.offset,
					},
					'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
						borderColor: themeVars.color.gray[600],
						borderWidth: themeVars.border.width,
					},
				},
				input: {
					transform: 'translate(0, 10px)',
					fontSize: '18px',
					fontFamily: 'Montserrat',
					color: themeVars.color.gray[600],
					minHeight: '1.4375em',
					height: 'auto',
					'&:not(.MuiSelect-select)~fieldset legend span': {
						display: 'none',
					},
				},
			},
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {
					fontFamily: 'Montserrat',
				},
			},
		},
		MuiFormControl: {
			defaultProps: {
				fullWidth: true,
			},
		},
		MuiTabs: {
			styleOverrides: {
				root: {
					minHeight: 'unset',
					overflow: 'visible',
					'& .MuiTabs-scroller': {
						overflow: 'visible !important',
					},
					'& .MuiTabs-indicator': {
						height: '4px',
					},
					'&[disabled] .MuiTabs-indicator': {
						height: '4px',
						backgroundColor: themeVars.color.gray[100],
					},
				},
			},
		},
		MuiTab: {
			defaultProps: {
				disableRipple: true,
			},
			styleOverrides: {
				root: {
					maxWidth: 'unset',
					minHeight: 'unset',
					padding: '4px 16px 2px',
					paddingBottom: '9px',
					borderBottom: 'solid 1px',
					borderColor: themeVars.color.gray[300],
					color: themeVars.color.gray[500],
					borderTopLeftRadius: themeVars.border.radius,
					borderTopRightRadius: themeVars.border.radius,
					'&:active': {
						backgroundColor: themeVars.color.blue[100],
						boxShadow: 'none',
					},
					'&.Mui-focusVisible': {
						outline: `${themeVars.color.blue[500]} ${themeVars.outline.width} ${themeVars.outline.style}`,
						outlineOffset: themeVars.outline.offset,
					},
					'&.Mui-disabled': {
						color: themeVars.color.gray[300],
						borderColor: themeVars.color.gray[100],
					},
				},
			},
		},
		MuiDialog: {
			styleOverrides: {
				paper: {
					boxShadow: '0px 0px 15px rgba(0, 0, 0, 0.25)',
				},
			},
		},
		MuiBackdrop: {
			styleOverrides: {
				root: {
					backgroundColor: '#ffffffcc',
				},
			},
		},
		MuiFormControlLabel: {
			styleOverrides: {
				label: {
					color: themeVars.color.gray[600],
					fontSize: '18px',
				},
			},
		},
		MuiDialogContent: {
			styleOverrides: {
				root: {
					justifyContent: 'center',
					marginBottom: 0,
					'&>*:not(:last-child)': {
						marginBottom: themeVars.spacing,
					},
				},
			},
		},
		MuiRadio: {
			defaultProps: {
				disableRipple: true,
				checkedIcon: <RadioSelectedSvg />,
			},
			styleOverrides: {
				root: {
					marginRight: '7px',
					color: themeVars.color.blue[500],
					'&:hover': {
						boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.3)',
					},
					'&:active': {
						boxShadow: 'none',
					},
					'&.Mui-focusVisible': {
						outline: `${themeVars.color.blue[500]} ${themeVars.outline.width} ${themeVars.outline.style}`,
						outlineOffset: themeVars.outline.offset,
					},
					'&.Mui-disabled': {
						color: themeVars.color.blue[200],
					},
				},
			},
		},
		MuiIconButton: {
			styleOverrides: {
				root: {
					'&.Mui-disabled': {
						'& svg path': {
							fill: themeVars.color.gray[300],
						},
					},
				},
			},
		},
	},
};

type RecursivePartial<T> = {
	[P in keyof T]?: RecursivePartial<T[P]>;
};
type ThemeVars = typeof themeVars;
type TypographyVars = typeof typographyVars;
declare module '@mui/material/styles' {
	interface Theme extends ThemeVars {}
	interface ThemeOptions extends RecursivePartial<ThemeVars> {}
	interface TypographyVariants extends TypographyVars {}
	interface TypographyVariantsOptions extends RecursivePartial<TypographyVars> {}
	interface BreakpointOverrides {
		xxl: true;
	}
}
type OptionsEnabled<T> = {
	[P in keyof T]?: true;
};
declare module '@mui/material/Typography' {
	interface TypographyPropsVariantOverrides extends OptionsEnabled<TypographyVars> {}
}
